import { z } from 'zod';

export const PlatformLoginBodySchema = z.object({
  email: z.email(),
  password: z.string().min(8),
});

export type PlatformLoginBody = z.infer<typeof PlatformLoginBodySchema>;

export const PlatformLoginResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  expiresIn: z.number().int().positive(),
  tokenType: z.literal('Bearer'),
});

export type PlatformLoginResponse = z.infer<typeof PlatformLoginResponseSchema>;

export const PlatformMeResponseSchema = z.object({
  userId: z.uuid(),
  email: z.email(),
  fullName: z.string(),
  scopeType: z.literal('SYSTEM'),
  roles: z.array(z.string()),
});

export type PlatformMeResponse = z.infer<typeof PlatformMeResponseSchema>;
